import React, { useState, useEffect } from 'react';

export default function ChanceLanding({ nextPage, selectedCards, setSelectedCards, prizes, currentChance, b }) {
    const [showContent, setShowContent] = useState(false);
    const [hoveredCard, setHoveredCard] = useState(null);

    // Color palette based on brand
    const colors = b === 2 ? {
        bgFrom: '#8B2500',
        bgVia: '#C4621F',
        bgTo: '#E87722',
        primary: '#F59E42',
        primaryLight: '#FFA94D',
        buttonFrom: '#F59E42',
        buttonTo: '#FFA94D',
        cardGradient: 'linear-gradient(to bottom right, #F59E42, #FB923C)',
        textAccent: '#FED7AA',
        textLight: '#FFEDD5',
        glow: 'rgba(245, 158, 66, 0.3)'
    } : {
        bgFrom: '#1A0D2E',
        bgVia: '#5D1A5E',
        bgTo: '#B81F7B',
        primary: '#EC4899',
        primaryLight: '#F472B6',
        buttonFrom: '#EC4899',
        buttonTo: '#F472B6',
        cardGradient: 'linear-gradient(to bottom right, #F472B6, #A855F7)',
        textAccent: '#F9A8D4',
        textLight: '#FBCFE8',
        glow: 'rgba(236, 72, 153, 0.3)'
    };

    useEffect(() => {
        setTimeout(() => setShowContent(true), 300);
    }, []);

    const cards = Array.from({ length: 9 }, (_, i) => i + 1);

    const handleCardClick = (cardNumber) => {
        if (selectedCards.includes(cardNumber) || currentChance >= 3) {
            return;
        }
        setSelectedCards([...selectedCards, cardNumber]);
        nextPage(cardNumber);
    };

    const isCardSelected = (cardNumber) => selectedCards.includes(cardNumber);
    const remainingChances = 3 - selectedCards.length;

    return (
        <div 
            className='flex flex-col items-center justify-center w-full min-h-screen relative overflow-hidden px-6 py-8'
            style={{ background: `linear-gradient(to bottom right, ${colors.bgFrom}, ${colors.bgVia}, ${colors.bgTo})` }}
        >
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-20 left-10 w-32 h-32 rounded-full blur-3xl animate-float" style={{ backgroundColor: colors.glow }}></div>
                <div className="absolute bottom-20 right-10 w-40 h-40 rounded-full blur-3xl animate-float-delayed" style={{ backgroundColor: colors.glow }}></div>
                <div className="absolute top-1/2 left-1/3 w-36 h-36 rounded-full blur-2xl animate-pulse" style={{ backgroundColor: colors.glow }}></div>
            </div>

            <div className={`relative z-10 w-full max-w-lg transition-all duration-700 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                <div className="text-center mb-8 animate-fade-in">
                    <div className="inline-block bg-white/10 backdrop-blur-sm px-8 py-4 rounded-3xl shadow-2xl border border-white/20 mb-4">
                        <h1 className='text-3xl font-bold text-white drop-shadow-2xl'>Pick Your Card</h1>
                    </div>
                    {/* <div className="flex items-center justify-center gap-3 mt-4">
                        <div className="px-6 py-3 rounded-2xl shadow-lg" style={{ background: `linear-gradient(to right, ${colors.buttonFrom}, ${colors.buttonTo})` }}>
                            <p className="text-white font-bold text-lg">
                                {remainingChances} {remainingChances === 1 ? 'Chance' : 'Chances'} Left
                            </p>
                        </div>
                    </div> */}
                    {/* <p className="text-sm mt-3" style={{ color: colors.textLight }}>✨ Tap on 3 cards to reveal your prizes! ✨</p> */}
                </div>

                <div className="grid grid-cols-3 gap-4 mb-8 animate-slide-up">
                    {cards.map((cardNumber, index) => {
                        const selected = isCardSelected(cardNumber);
                        const delay = index * 0.05;
                        return (
                            <button
                                key={cardNumber}
                                onClick={() => handleCardClick(cardNumber)}
                                onMouseEnter={() => setHoveredCard(cardNumber)}
                                onMouseLeave={() => setHoveredCard(null)}
                                disabled={selected || remainingChances === 0}
                                className={`relative aspect-square rounded-2xl overflow-hidden transition-all duration-300 transform
                                    ${selected ? 'opacity-40 scale-95 cursor-not-allowed' : 'hover:scale-105 active:scale-95 cursor-pointer'}
                                    ${hoveredCard === cardNumber && !selected ? 'animate-pulse-fast' : ''} animate-card-appear`}
                                style={{ 
                                    animationDelay: `${delay}s`, 
                                    touchAction: 'manipulation',
                                    background: selected ? colors.cardGradient : colors.cardGradient,
                                    opacity: selected ? 0.4 : 0.8
                                }}
                            >
                                {!selected && hoveredCard === cardNumber && (
                                    <div className="absolute inset-0 bg-white/20 animate-pulse-glow"></div>
                                )}
                                <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/10 backdrop-blur-sm border-2 border-white/30">
                                    {selected ? (
                                        <div className="text-center animate-fade-in">
                                            <div className="text-5xl mb-2">✓</div>
                                            <p className="text-white text-xs font-semibold">Selected</p>
                                        </div>
                                    ) : (
                                        <div className="text-center">
                                            <div className="text-6xl mb-2 animate-bounce-subtle">🎁</div>
                                            <p className="text-white text-sm font-bold drop-shadow-lg">{cardNumber}</p>
                                        </div>
                                    )}
                                </div>
                                {!selected && (
                                    <>
                                        <div className="absolute top-2 left-2 text-lg animate-sparkle">✨</div>
                                        <div className="absolute top-2 right-2 text-lg animate-sparkle" style={{ animationDelay: '0.5s' }}>✨</div>
                                        <div className="absolute bottom-2 left-2 text-lg animate-sparkle" style={{ animationDelay: '1s' }}>⭐</div>
                                        <div className="absolute bottom-2 right-2 text-lg animate-sparkle" style={{ animationDelay: '1.5s' }}>⭐</div>
                                    </>
                                )}
                            </button>
                        );
                    })}
                </div>

                {/* {prizes.length > 0 && (
                    <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 shadow-2xl border border-white/20 animate-slide-up">
                        <h2 className="text-2xl font-bold text-white text-center mb-4 flex items-center justify-center gap-2">
                            <span>🎊</span>What You Got<span>🎊</span>
                        </h2>
                        <div className="grid grid-cols-3 gap-4">
                            {prizes.map((prize, index) => (
                                <div key={index} className="relative aspect-square animate-prize-appear" style={{ animationDelay: `${index * 0.2}s` }}>
                                    <div className="absolute -inset-1 rounded-2xl blur-lg animate-pulse-glow" style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})`, opacity: 0.3 }}></div>
                                    <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden border-2 border-white/30 shadow-xl">
                                        <img src={prize.image} alt={`Card ${prize.cardNumber}`} className="w-full h-full object-cover"/>
                                        <div className="absolute top-2 left-2 text-white text-xs font-bold px-2 py-1 rounded-full shadow-lg" style={{ background: `linear-gradient(to right, ${colors.buttonFrom}, ${colors.buttonTo})` }}>
                                            #{prize.cardNumber}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )} */}

                {remainingChances === 0 && (
                    <div className="mt-8 animate-fade-in">
                        <button
                            onClick={() => nextPage('status')}
                            className="w-full text-white font-bold text-xl rounded-2xl px-8 py-5 shadow-2xl transition-all duration-300 transform hover:scale-105 active:scale-95 overflow-hidden group relative"
                            style={{ 
                                background: `linear-gradient(to right, ${colors.buttonFrom}, ${colors.buttonTo})`,
                                boxShadow: `0 20px 50px ${colors.glow}`
                            }}
                        >
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                            <span className="relative z-10 flex items-center justify-center gap-2">
                                <span>See Results</span><span className="text-2xl">🎉</span>
                            </span>
                        </button>
                    </div>
                )}
            </div>

            <style jsx>{`
                @keyframes float { 0%, 100% { transform: translateY(0px) translateX(0px); } 50% { transform: translateY(-20px) translateX(10px); } }
                @keyframes float-delayed { 0%, 100% { transform: translateY(0px) translateX(0px); } 50% { transform: translateY(20px) translateX(-10px); } }
                @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slide-up { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes card-appear { from { opacity: 0; transform: scale(0.8) rotateY(90deg); } to { opacity: 1; transform: scale(1) rotateY(0deg); } }
                @keyframes prize-appear { from { opacity: 0; transform: translateX(-30px); } to { opacity: 1; transform: translateX(0); } }
                @keyframes bounce-subtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
                @keyframes sparkle { 0%, 100% { opacity: 1; transform: scale(1) rotate(0deg); } 50% { opacity: 0.5; transform: scale(1.3) rotate(180deg); } }
                @keyframes pulse-glow { 0%, 100% { opacity: 0.3; } 50% { opacity: 0.6; } }
                @keyframes pulse-fast { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
                .animate-float { animation: float 6s ease-in-out infinite; }
                .animate-float-delayed { animation: float-delayed 8s ease-in-out infinite; }
                .animate-fade-in { animation: fade-in 0.8s ease-out forwards; }
                .animate-slide-up { animation: slide-up 0.6s ease-out forwards; }
                .animate-card-appear { animation: card-appear 0.6s ease-out forwards; }
                .animate-prize-appear { animation: prize-appear 0.5s ease-out forwards; }
                .animate-bounce-subtle { animation: bounce-subtle 2s ease-in-out infinite; }
                .animate-sparkle { animation: sparkle 2s ease-in-out infinite; }
                .animate-pulse-glow { animation: pulse-glow 1.5s ease-in-out infinite; }
                .animate-pulse-fast { animation: pulse-fast 0.8s ease-in-out infinite; }
            `}</style>
        </div>
    );
}